import * as types from './types'

function toggleDefaultPaymentMethod (state, paymentMethod) {
	if (paymentMethod.is_default) {
		for (let index in state.paymentMethods) {
			state.paymentMethods[index].is_default = false
		}
	}
}

export const mutations = {
	[types.CLEAR_PAYMENT_METHOD] (state) {
		state.paymentMethods = []
	},
	[types.NEW_PAYMENT_METHOD] (state, paymentMethod) {
		toggleDefaultPaymentMethod(state, paymentMethod)

		state.paymentMethods.push(paymentMethod)
	},
	[types.EDIT_PAYMENT_METHOD] (state, paymentMethod) {
		toggleDefaultPaymentMethod(state, paymentMethod)

		let index = state.paymentMethods.findIndex((elem) => elem.id === paymentMethod.id)

		state.paymentMethods[index] = paymentMethod
	},
	[types.DELETE_PAYMENT_METHOD] (state, paymentMethodId) {
		state.paymentMethods = state.paymentMethods.filter((paymentMethod) => paymentMethod.id !== paymentMethodId)
	},
	[types.STRIPE_CLIENT_SECRET] (state, clientSecret) {
		state.clientSecret = clientSecret
	}
}



// WEBPACK FOOTER //
// ./src/common/store/PaymentMethod/mutations.js